// WO-V4-C / US-026 — cockpit HITL quotidien : agrégation en lecture + délégation de la
// décision aux mêmes autorités que le Centre d'approbations et les exécutions d'outils IA
// (rien de nouveau n'est décidé ici, seulement router et afficher).
import { request } from './http'
import type { HitlDecisionTimeMetrics, HitlKind, HitlPendingItem } from './types/hitl'

/**
 * Le `kind` du DOMAINE (`ai_tool_execution`, retourné tel quel par `HitlCockpitService` et
 * utilisé pour le libellé/les `data-testid`) N'EST PAS le segment de ROUTE REST du
 * contrôleur (`HitlCockpitController` expose `/decisions/ai-tool-execution/{id}/decision`,
 * convention kebab-case des chemins). Les confondre a produit un 404 réel — mesuré par le
 * parcours Playwright `tests/hitl-cockpit.spec.ts` — puisque `fetch` construisait
 * `/hitl/decisions/ai_tool_execution/...`, une route que Spring ne reconnaît pas.
 */
function segmentDeRoute(kind: HitlKind): string {
  return kind === 'ai_tool_execution' ? 'ai-tool-execution' : kind
}

export const hitlCockpitApi = {
  listHitlPendingDecisions: (workspaceId: string) =>
    request<HitlPendingItem[]>(
      `/hitl/pending-decisions?workspace_id=${encodeURIComponent(workspaceId)}`),

  getHitlDecisionTimeMetrics: (workspaceId: string, windowDays = 30) =>
    request<HitlDecisionTimeMetrics>(
      `/hitl/decision-time-metrics?workspace_id=${encodeURIComponent(workspaceId)}`
      + `&window_days=${encodeURIComponent(String(windowDays))}`),

  /** L'identité du décideur vient du jeton côté serveur — jamais transmise ici. */
  decideHitlItem: (kind: HitlKind, id: string, decision: 'approved' | 'rejected', comment?: string) =>
    request<{ kind: string; id: string; decision: string; decided_by: string }>(
      `/hitl/decisions/${segmentDeRoute(kind)}/${encodeURIComponent(id)}/decision`,
      { method: 'POST', body: JSON.stringify({ decision, ...(comment ? { comment } : {}) }) }),
}
